import { DeleteOutlined, UserAddOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Select, Table, Typography } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import {
  listUserPost,
  userPostAdd,
  userPostDelete
} from '../../services/postservice'
import openNotification from '../common/Notification/openNotification '
import styles from './styles.module.scss'
import {
  listManageRequest,
  requestManagerAdd,
  userRequestDelete
} from '../../services/requestservice'
import { removeVietnameseTones } from '../../config-func'
const { Option } = Select
const { Text } = Typography

const ManageRequestDetail = ({
  list = [],
  setLoading,
  loading,
  requestId,
  data = [],
  getList = () => {}
}) => {
  const [selectedManager, setSelectedManager] = useState(null)

  const handleDelete = async (id) => {
    const body = {
      // post_id: requestId,
      id: id
      // from: 2
    }

    try {
      const res = await userRequestDelete(body)
      openNotification('success', 'Xóa thành công quản lý yêu cầu')
      getList(requestId)
    } catch (err) {
      openNotification('error', 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const handleAdd = async () => {
    setLoading(true)
    try {
      const body = {
        ids: [requestId],
        assigner_id: selectedManager
        // from: 2
      }
      const res = await requestManagerAdd(body)
      if (res?.data?.list) {
        openNotification('success', 'Thêm thành công quản lý yêu cầu')
        getList(requestId)
      } else {
        openNotification('error', 'Có lỗi xảy ra')
      }
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setSelectedManager(null) // Reset giá trị Select sau khi gọi API
    }
  }


  return (
    <div className={styles.listManagePost}>
      <Table
        loading={loading}
        dataSource={list}
        pagination={false}
        rowKey="id"
        scroll={{ y: 300 }}
        bordered
        columns={[
          {
            title: 'Tên quản lý',
            dataIndex: 'name',
            key: 'name',
            width: '60%',
            render: (text, record) => `${record?.assigner_info?.name}`
          },
          {
            title: 'SĐT',
            dataIndex: 'phone',
            key: 'phone',
            width: '30%',
            render: (text, record) => `${record?.assigner_info?.phone}`
          },
          {
            key: 'action',
            render: (text, record) => (
              //   <Button
              //     type="text"
              //     danger
              //     icon={<DeleteOutlined />}
              //     onClick={() => handleDelete(record.manager_post_id)}
              //   />
              <Popconfirm
                title="Xóa quản lý yêu cầu?"
                onConfirm={() => handleDelete(record.id)}
              >
                <DeleteOutlined key="delete" style={{ color: 'red' }} />
              </Popconfirm>
            ),
            align: 'center'
          }
        ]}
      />

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 20
        }}
      >
        <div>Thêm quản lý:</div>
        <Select
          style={{ width: '70%' }}
          placeholder="Chọn quản lý"
          value={selectedManager} // Gán value từ state
          onChange={(value) => setSelectedManager(value)}
          allowClear
          showSearch
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase();
            const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
            return optionValue.includes(inputValue);
          }}
        >
          {data.map((item) => {
            const isDisabled = list?.some(
              (manager) => manager?.assigner_info?.id === item.id
            )

            return (
              <Option key={item.id} value={item.id} disabled={isDisabled}>
                {item.name}
              </Option>
            )
          })}
        </Select>

        <Button type="primary" icon={<UserAddOutlined />} onClick={handleAdd} />
      </div>
    </div>
  )
}

export default ManageRequestDetail
